import React from "react";
import { FaProjectDiagram, FaCube, FaLink, FaFileContract, FaLightbulb } from "react-icons/fa";

function PolkadotFeature({ icon: Icon, title, description }) {
  return (
    <div className="process-style-three-item fade-up-anim">
      <div className="icon" style={{ fontSize: "40px", color: "#ffffffff" }}>
        <Icon />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}

function ParachainDev() {
  const features = [
    {
      icon: FaProjectDiagram,
      title: "Parachain Development",
      description:
        "Our developers create custom parachains that maximize scalability and interoperability, integrating your blockchain project seamlessly with the Polkadot ecosystem.",
    },
    {
      icon: FaCube,
      title: "Polkadot DApp Development",
      description:
        "We build powerful DApps on Polkadot that leverage its decentralized, scalable infrastructure for seamless user experiences and network efficiency.",
    },
    {
      icon: FaLink,
      title: "Cross-Chain Bridge Development",
      description:
        "Our cross-chain solutions allow your Polkadot project to interact with other blockchain networks, enhancing reach and usability across ecosystems.",
    },
    {
      icon: FaFileContract,
      title: "Smart Contract Development",
      description:
        "Using Polkadot’s Substrate framework, we create secure and efficient smart contracts that automate processes and drive innovation for businesses.",
    },
    {
      icon: FaLightbulb,
      title: "Polkadot Consulting and Strategy",
      description:
        "Xeer’s consultants provide insights and strategic planning to help you navigate Polkadot’s ecosystem and maximize its potential for your project.",
    },
  ];

  return (
    <div
      className="process-style-three-area default-padding bg-dark text-light bg-cover"
      style={{
        backgroundImage:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
      }}
    >
      <div className="shape">
        <img
          src="https://validthemes.net/site-template/robok/assets/img/illustration/16.png"
          alt="Image Not Found"
        />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="site-heading">
              <h4 className="sub-title">How it works</h4>
              <h2 className="title split-text-right split-text-in-right">
                Xeer’s Polkadot Blockchain Development Services
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-11 offset-lg-2">
            <div className="process-style-three-items">
              {features.map((feature, idx) => (
                <PolkadotFeature key={idx} {...feature} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ParachainDev;